import React from 'react';
import { GiftIcon, ClockIcon, PlayCircleIcon, TargetIcon } from 'lucide-react';
export function Offer() {
  return <section className="py-16 border-t border-black" data-id="element-164">
      <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center" data-id="element-165">
        Oferta Especial <span className="text-orange-400" data-id="element-166">Limitada</span>
      </h2>
      <div className="bg-gradient-to-r from-orange-900 to-black p-8 rounded-lg mb-10" data-id="element-167">
        <h3 className="text-xl font-bold mb-6 text-center" data-id="element-168">
          Cuando reservas tu llamada hoy:
        </h3>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-169">
          <div className="bg-black/50 p-5 rounded-lg flex" data-id="element-170">
            <GiftIcon className="h-10 w-10 text-orange-500 mr-4 flex-shrink-0" data-id="element-171" />
            <div data-id="element-172">
              <h4 className="font-bold mb-1" data-id="element-173">Consultoría Personalizada</h4>
              <p className="text-gray-300" data-id="element-174">
                30 minutos exclusivos para analizar tu negocio
              </p>
            </div>
          </div>
          <div className="bg-black/50 p-5 rounded-lg flex" data-id="element-175">
            <ClockIcon className="h-10 w-10 text-orange-500 mr-4 flex-shrink-0" data-id="element-176" />
            <div data-id="element-177">
              <h4 className="font-bold mb-1" data-id="element-178">Acceso Anticipado</h4>
              <p className="text-gray-300" data-id="element-179">
                Contenido exclusivo antes del lanzamiento oficial
              </p>
            </div>
          </div>
          <div className="bg-black/50 p-5 rounded-lg flex" data-id="element-180">
            <PlayCircleIcon className="h-10 w-10 text-orange-500 mr-4 flex-shrink-0" data-id="element-181" />
            <div data-id="element-182">
              <h4 className="font-bold mb-1" data-id="element-183">Demo en Vivo</h4>
              <p className="text-gray-300" data-id="element-184">
                Cómo un funnel con IA se aplica a tu negocio
              </p>
            </div>
          </div>
          <div className="bg-black/50 p-5 rounded-lg flex" data-id="element-185">
            <TargetIcon className="h-10 w-10 text-orange-500 mr-4 flex-shrink-0" data-id="element-186" />
            <div data-id="element-187">
              <h4 className="font-bold mb-1" data-id="element-188">Descuento Exclusivo</h4>
              <p className="text-gray-300" data-id="element-189">
                Asegura tu lugar con precio especial tras la llamada
              </p>
            </div>
          </div>
        </div>
        <div className="mt-8 text-center" data-id="element-190">
          <p className="text-lg font-bold mb-6 text-orange-300" data-id="element-191">
            ¡Estas bonificaciones solo están disponibles para quienes agendan
            esta semana!
          </p>
          <button className="bg-orange-500 hover:bg-orange-600 text-black font-bold py-4 px-8 rounded-full text-xl transition-all transform hover:scale-105" data-id="element-192">
            Agendar mi llamada estratégica
          </button>
        </div>
      </div>
      <div className="text-center" data-id="element-193">
        <p className="text-sm text-gray-400" data-id="element-194">
          * Los resultados pueden variar. El éxito depende de la aplicación
          correcta de las estrategias enseñadas.
        </p>
      </div>
    </section>;
}